module.exports = __webpack_public_path__ + "assets/img/img255.4070aa4f.png";